import drop from "lodash/drop";

export const getPagedData = (data: any, pageIndex: number, pageSize: number) => {
  if (!(pageIndex >= 0)) {
    throw Error("GetPagedData: pageIndex must be 0 or greater.");
  }

  if (!(pageSize > 0)) {
    throw Error("GetPagedData: pageSize must be greater than 0.");
  }

  const offset = pageIndex * pageSize;
  const pagedData = drop(data, offset).slice(0, pageSize);

  return pagedData;
};
